const CentraJS = {
    suspend: ()=>{
        var _window_CentraCheckout;
        if (typeof window === "undefined") return;
        (_window_CentraCheckout = window.CentraCheckout) == null ? void 0 : _window_CentraCheckout.suspend();
    },
    resume: (suspendIgnore)=>{
        var _window_CentraCheckout;
        if (typeof window === "undefined") return;
        (_window_CentraCheckout = window.CentraCheckout) == null ? void 0 : _window_CentraCheckout.resume(suspendIgnore);
    },
    reInitiate: (key)=>{
        var _window_CentraCheckout;
        if (typeof window === "undefined") return;
        (_window_CentraCheckout = window.CentraCheckout) == null ? void 0 : _window_CentraCheckout.reInitiate(key);
    }
};

export { CentraJS };
